import { render, staticRenderFns } from "./EachDistrictServingElderByAssessment.vue?vue&type=template&id=3fc2ced9&scoped=true&"
import script from "./EachDistrictServingElderByAssessment.vue?vue&type=script&lang=js&"
export * from "./EachDistrictServingElderByAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2ced9",
  null
  
)

export default component.exports